export default __webpack_public_path__ + "static/media/in-company-card.4120025e.svg";